<template>
  <sui-segment vertical :loading="$store.state.billing.inProgress">
    <template v-if="$store.state.device.devices == null">
      <span class="message">Loading Devices ...</span>
    </template>
    <template v-else>
      <template v-if="$store.getters['device/needForBilling'] === false">
        <span class="message">There is no need to set up billing<br>as you have no billable devices</span>
      </template>
      <template v-else>
        <sui-message error v-if="$store.state.billing.error !== ''">{{$store.state.billing.error}}</sui-message>
        <sui-grid :columns="1">
          <sui-grid-row stretched>
            <sui-grid-column :width="16">
              <sui-container vertical>
                <sui-header floated="left">SIM Plan Billing Settings</sui-header>
                <sui-button icon="cancel" compact basic color="pink" @click="removeBilling" v-if="billingCustomer && billingCustomer.ID && $store.getters.isAdmin === true">Remove Billing</sui-button>
                <sui-divider />
                <billing-info v-if="!billingCustomer || !billingCustomer.ID" @change-payment-details="changePaymentDetails" />
                <billing-info-read v-else :data="billingCustomer" @change="changePaymentDetails"></billing-info-read>
              </sui-container>
            </sui-grid-column>
          </sui-grid-row>
          <sui-grid-row stretched v-if="billingCustomer && billingCustomer.ID && billingCustomer.CardLast4">
            <sui-grid-column :width="16">
              <sui-container vertical>
                <h3 is="sui-header">My Devices</h3>
                <sui-divider />
                <device-plan-table :data="$store.state.device.devices" :billing-customer="billingCustomer"  />
              </sui-container>
            </sui-grid-column>
          </sui-grid-row>
        </sui-grid>
        <div class="spacemaker mobile only">
        </div>
        <payment-details v-if="openPaymentDetails" v-on:complete="onPaymentDetailsComplete" :message="paymentDetailsMessage" :billing-customer="billingCustomer"/>
        {{this.$store.state.billing.addCardResponse}}
      </template>
    </template>
  </sui-segment>

</template>
<script>
  import {mapState} from 'vuex'
  import StripeUtils from '../utils/StripeUtils'
  import BillingInfo from "../components/billing/BillingInfo";
  import SuiDivider from "semantic-ui-vue/dist/commonjs/elements/Divider/Divider";
  import DevicePlanTable from "../components/billing/DevicePlanTable";
  import PaymentDetails from "../components/billing/PaymentDetails";
  import BillingInfoRead from "../components/billing/BillingInfoRead";
  export default {
    components: {BillingInfoRead, PaymentDetails, DevicePlanTable, SuiDivider, BillingInfo},
    data: function() {
      return {
        openPaymentDetails: false,
        closePaymentDetailsHandler: null,
        paymentDetailsMessage: ""
      }
    },
    computed: {
      ...mapState({
        subscribeResponse: state => (state.billing || {}).subscribeResponse,
        subscribeResult: state => (state.billing || {}).subscribeResult,
        subscribePISecret: state => (state.billing || {}).subscribePISecret,
        billingCustomer: state => ((state.billing || {}).getBillingResponse || {}).BillingCustomer,
      }),
    },
    methods: {
      async removeBilling () {
        let confirmation = confirm(`Are you absolutely sure? Please press OK if you want to remove billing`);
        if (confirmation) {
          await this.$store.dispatch('billing/removeBilling')
          this.$store.dispatch('billing/getBilling')
        }
      },
      async onPaymentDetailsComplete(tokenID) {
        this.openPaymentDetails = false
        if (this.closePaymentDetailsHandler && tokenID) {
          this.closePaymentDetailsHandler(tokenID)
        }
      },
      async enterPaymentDetails(message) {
        return new Promise((resolve) => {
          this.openPaymentDetails = true
          this.paymentDetailsMessage = message
          this.closePaymentDetailsHandler = (tokenID) => {
            this.paymentDetailsMessage = ""
            this.closePaymentDetailsHandler = null
            resolve(tokenID)
          }
        })
      },
      async changePaymentDetails() {
        let tokenID = await this.enterPaymentDetails("Please enter your payment details")
        await this.$store.dispatch('billing/addCard', tokenID)
        if (!this.$store.state.billing.error) {
          this.$store.dispatch('billing/getBilling')
        }
      }
    },
    mounted() {
      this.$store.dispatch('billing/getBilling')
    },
    watch: {
      async subscribeResult(newValue) {
        let store = this.$store
        if (!newValue) return
        let result
        let paymentIntentSecret = this.subscribePISecret
        let tokenID
        switch (newValue) {
          case StripeUtils.RESULT_PAID:
            break
          case StripeUtils.RESULT_ACTION:
            result = await StripeUtils.getStripe().handleCardPayment(paymentIntentSecret)
            if (result.error) {
              alert('There was a problem')
            } else {
              store.dispatch('billing/getBilling')
            }
            break
          case StripeUtils.RESULT_FAIL:
            tokenID = await this.enterPaymentDetails("The has been declined, please enter details again")
            await store.dispatch('billing/addCard', tokenID)
            if (!this.$store.state.billing.error) {
              this.$store.dispatch('billing/getBilling')
            }
            break
        }
      }
    }
  }
</script>

<style scoped>
  .message {
    display: block;
    padding: 10pt;
    text-align: center;
  }
  .spacemaker {
    /* this fixes the scrolling on phones */
    height: 300pt;
  }

</style>
